import {
  CHANGE_PAGE_INVOICES,
  FETCH_INVOICES,
  FETCH_INVOICE_LIST_SUCCESS,
  SET_SEARCH_TEXT_INVOICES,
    CHANGE_STATUS
} from 'invoices/actions/types'

const initialState = {
  invoiceList: [],
  currentPage: 1,
  searchText: '',
  invoiceListIsLoading: true,
  totalCount: 0,
  status: '',
  pageCount: 0
}

export default function invoices (state = initialState, action) {
  switch (action.type) {
    case FETCH_INVOICES:
      return {
        ...state,
        invoiceListIsLoading: true,
      }
    case FETCH_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        invoiceList: action.invoiceList,
        totalCount: action.totalCount,
        pageCount: action.pageCount,
        currentPage: action.currentPage,
        sizePerPage: action.sizePerPage,
        invoiceListIsLoading: false,
      }
    case CHANGE_PAGE_INVOICES:
      return {
        ...state,
        currentPage: action.currentPage
      }
    case SET_SEARCH_TEXT_INVOICES:
      return {
        ...state,
        searchText: action.searchText
      }
    case CHANGE_STATUS:
      return {
        ...state,
        status: action.status
      }
    default:
      return state
  }
}
